
<div class="air-details-container" >
  <div *ngIf="!isShowMainBlock">
    <div class="section-title">
      Inspections Look Ahead Report - Build Search
    </div>
    <div class="partioned-table">
      <div class="row">
        <div class="cell label label-text">Recommended Repair Date Rang
        </div>
        <div class="cell value"> <p-dropdown [options]="days" [(ngModel)]="filters.days" 
          optionLabel="label" optionValue="value"
          placeholder="30 days" class="dropdown" class="custom-dropdown" 
          panelStyleClass="custom-dropdown-panel"
            ></p-dropdown>
        </div>
      </div>
      <div class="row">
        <div class="cell label label-text">Repair Type
        </div>
        <div class="cell value">
                    <p-dropdown [options]="repairtype" [(ngModel)]="filters.repairtype"
                    optionLabel="name" optionValue="value"
                        placeholder="ALL" class="dropdown" class="custom-dropdown w-100"
                        ></p-dropdown>
        </div>
      </div>
      <div class="row">
        <div class="cell label label-text">Division
        </div>
        <div class="cell value">
                    <p-dropdown [options]="divisions" [(ngModel)]="filters.divisions"
                    optionLabel="name" optionValue="value"
                        placeholder="ALL" class="dropdown" class="custom-dropdown w-200"
                        ></p-dropdown>
        </div>
      </div>
      <div class="row">
        <div class="cell label label-text">Section
        </div>
        <div class="cell value">
                    <p-dropdown [options]="sections" [(ngModel)]="filters.sections"
                    optionLabel="name" optionValue="value"
                        placeholder="ALL" class="dropdown" class="custom-dropdown w-300"
                        ></p-dropdown>
        </div>
      </div>
      <div class="row">
        <div class="cell label label-text">Plant
        </div>
        <div class="cell value">
                    <p-dropdown [options]="plants" [(ngModel)]="filters.plants"
                    optionLabel="name" optionValue="value"
                        placeholder="ALL" class="dropdown" class="custom-dropdown w-400"
                        ></p-dropdown>
        </div>
      </div>
      <div class="row">
        <div class="cell label label-text">Associated Plant - Shutdown
        </div>
        <div class="cell value">
                    <p-dropdown [options]="associatedPlants" [(ngModel)]="filters.associatedPlants"
                    optionLabel="name" optionValue="value"
                        placeholder="ALL" class="dropdown" class="custom-dropdown w-400"
                        ></p-dropdown>
        </div>
      </div>
    </div>
    <div class="button-row">
      <button (click)="runReport()">Run Report</button>
    </div>

  </div>

  <div *ngIf="isShowMainBlock">

   
    <div class="table-chart-container mt-10">
      <div class="display-flex">
        <div class="section-title">Inspections Look Ahead Report Details</div>
        <p class="m-0">
          Date Range: <b>{{filters.days}} Days </b> Repair Type: <b>{{filters.repairtype}} </b> Division: <b>
            {{filters.divisions}} </b> Section: <b>{{filters.sections}}</b> Plant: <b>{{filters.plants}}</b> Associated
          plant-Shutdown: <b>{{filters.associatedPlants}}</b>
        </p>
        <div class="exportToExcel excel-btn">
          <div class="actions">
            <button pButton type="button" label="Export To Excel" icon="pi pi-file-excel" class="p-button-outlined" (click)="exportToExcel()">Export To Excel</button>
          </div>
        </div>
      </div>
      <p-table [value]="reportData" [paginator]="true" [rows]="10" responsiveLayout="scroll">
        <ng-template pTemplate="header">
          <tr>
            <th>Tag Number</th>
            <th>Entry Date</th>
            <th>TLR Status</th>
            <th>Op. User ID</th>
            <th>Division</th>
            <th>Section</th>
            <th>Plant</th>
            <th>LDAR</th>
            <th>Op. PSI</th>
            <th>Op. Temp</th>
            <th>ShutdownDescription</th>
            <th>Service</th>
            <th>Insp. User ID</th>
            <th>Service Class</th>
            <th>OA User ID</th>
            <th>Permanent Repair Date</th>
            <th>Eng. User ID</th>
            <th>TLR Type</th>
            <th>Maximo WO Number</th>
            <th>Maximo Outage-T/A</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-data>
            <tr let data of reportData >
            <td><a routerLink="/details-section/{{data.Tag_Number}}">
                {{ data.Tag_Number }}</a></td>
            <td>{{data.Data_Entry_Date | date:'MM/dd/yyyy'}}</td>
            <td>{{data.TLR_Status}}</td>
            <td>{{data.Operator_CAI}}</td>
            <td>{{data.Division}}</td>
            <td>{{data.Section}}</td>
            <td>{{data.Plant}}</td>
            <td>{{data.LDAR}}</td>
            <td>{{data.Oper_PSI}}</td>
            <td>{{data.Oper_Temp}}</td>
            <td>{{data.ShutdownDescription}}</td>
            <td>{{data.Service}}</td>
            <td>{{data.InspectionCAI}}</td>
            <td>{{data.ServiceClass}}</td>
            <td>{{data.OACAI}}</td>
            <td [ngClass]="commonService.getDateColorClass(data.Permanent_Repair_Date)">{{data.Permanent_Repair_Date| date:'MM/dd/yyyy'}}</td>
            <td>{{data.EngineeringCAI}}</td>
            <td>{{data.TLRType}}</td>
            <td>{{data.Maximo_WO_Number}}</td>
            <td>{{data.Maximo_Outage_T_A}}</td>

          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>